exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-095d7e7b] {\n  resize: none;\n}", ""]);

// exports
